//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: { type: String, required: true },
    slug: { type: String, required: true }
  },

  data() {
    return { copied: false };
  },

  computed: {
    pageUrl() {
      return `https://bomist.com/blog/${this.slug}`;
    },
    encodedUrl() {
      return encodeURIComponent(this.pageUrl);
    },
    encodedTitle() {
      return encodeURIComponent(this.title);
    }
  },

  methods: {
    async copyLink() {
      try {
        await navigator.clipboard.writeText(this.pageUrl);
      } catch {
        // fallback for older browsers
        const el = document.createElement('textarea');
        el.value = this.pageUrl;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      }
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    }
  }
};
